import React, { useState, useEffect, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import Header from "../elements/Header";
import Postbox from "../elements/Postbox";
import "./CentralContent.css";
import Post from "../elements/Post";
import ErrorMessage from "../elements/ErrorMessage";
import { useLocation, useParams } from "react-router-dom";
import { UserContext } from "../context/UserContext";

function CentralContent() {
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const { user } = useContext(UserContext);
  const [posts, setPosts] = useState([]);
  const [response, setResponse] = useState({ ok: true });
  const [responseData, setResponseData] = useState({});
  const location = useLocation();
  const { hashtag, username } = useParams();
  let title;
  if (hashtag) {
    title = "#" + hashtag;
  } else {
    title = username;
  }

  function childUpdate() {
    setShouldUpdate(!shouldUpdate);
  }

  useEffect(() => {
    async function fetchData() {
      try {
        let query;
        if (window.location.pathname === "/") {
          query = "/posts";
        } else {
          query = window.location.pathname;
        }

        let url = process.env.REACT_APP_CONNECTION_URL + query;
        const response = await fetch(url);
        const responseData = await response.json();

        setResponse(response);
        setPosts(responseData.posts);
        setResponseData(responseData);
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, [location, shouldUpdate]);

  return (
    <div className="centralcontent">
      <div className="centralcontent_centralcontainer">
        <Header title={title} />

        <div className="posts-and-postbox">
          {location.pathname === "/" && user && (
            <Postbox childUpdate={childUpdate} />
          )}

          {!response.ok && <ErrorMessage message={responseData.message} />}
          <div className="posts">
            {posts &&
              posts
                .slice(0)
                .reverse()
                .map((post) => (
                  <Post
                    key={uuidv4()}
                    body={post.body}
                    creator={post.creator.username}
                  />
                ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CentralContent;
